// Kendo related Utilities
import * as $ from 'jquery';

import {
  IMarkupCustomization as IBaseMarkupCustomization, EnsureStyle
} from '../style';
import {
  fn
} from '../utils';
import UISafe = fn.UISafe;
import { NumericType, NavDtFormat, IPageProperty } from '../nav/navtypes';
import { CreateSetting } from '../services/settingsservice';
import { Model, Observable, ObservableArray, IObservableArray, GridColumn } from '../nav/navmodel';

/** Property Names to Render as link if applicapple */
export const RenderAsLinkProps = new Array<string>();

/**  */
export interface IPropDisplayValueConfig {
  FullDecimals?: boolean;
}
/** Get Value as String For Display */
export function GetPropDisplayValue(this: void, value: any, prop: IPageProperty, config?: IPropDisplayValueConfig): string {
  if (!(prop && prop.Type))
    return value;

  switch (prop.Type) {
    case "String":
      return value == undefined ? "" : value;
    case "Boolean":
      return value == true ? "Ja" : (value == false ? "Nein" : value);

    case "Decimal":
      var format = NumericFormat[prop.DecimalNumericType];

      if (config && config.FullDecimals && typeof (value) === "number") {
        if (Math.floor(value) !== value.valueOf()) {
          const cnt = value.toString().split('.')[1].length;
          if (cnt > 2) {
            return kendo.format("{0:C" + cnt + "}", value);
          }
        }
      }
      return format ? kendo.format(format, value) : value;

    case "Int32":
      if (value == null && value == undefined)
        return "";
      return parseInt(value).toString();

    case "DateTime":
      return (value && kendo.format(DateFormat[prop.DateFormat || 0], value)) || "";

    default:
      if (prop.EnumMappings) {
        var map = prop.EnumMappings.filter(item => item.Value == value)[0];
        return map ? map.Title : value;
      } else
        return;
  }
}

/** Register custom Class with kendo Widget system (and implicitly kendo-angular - system)*/
export function NavKendoRegister(customWidget: typeof kendo.ui.Widget, name: string, exOptions?: any, events?: string[], mobile?: boolean) {
  customWidget.fn = customWidget.prototype;
  // extend options as clone and extend/apply external options
  var options = $.extend(true, {}, customWidget.prototype.options, exOptions);
  options.name = name;
  customWidget.fn.options = options;
  if (events) {
    events.push(...customWidget.fn.events);
    customWidget.fn.events = fn.distinct(events);
  }

  if (mobile) {
    kendo.ui.plugin(customWidget, kendo.mobile.ui);
  } else {
    kendo.ui.plugin(customWidget);
  }
}

function resolveKendoVersion<T>(ver2016: T, ver2019: T) {
  switch (kendo && kendo.version) {
    case "2019.2.807":
      return ver2019;
    case "2016.1.412":
      return ver2016;
    default:
      if (typeof (console && console.error) === "function")
        console.error("kendo :unexpected Version " + kendo.version);
      return undefined;
  }
}

/** JQuery Event triggered when iFrame Overlay ("Adobe plugin  in foreground - problem") is shown */
export const ShowOverlay = "ShowOverlay";
/** JQuery Event triggered when iFrame Overlay ("Adobe plugin  in foreground - problem") is hidden */
export const HideOverlay = "HideOverlay";

/** Create IFrame Overlay behind element, moving with element -> necessary if 'heavyweight' objects (pdf) will force themselves in front */
export function CreateOverlay(target: JQuery, offset?: { Left?: number, Top?: number, Width?: number, Height?: number, zIndex?: number, Insert?: JQuery }) {
  offset = $.extend({ Left: 0, Top: 0, Width: 0, Height: 0 }, offset || {});
  var overlay = $('<iframe tabindex="-1" frameborder="0" scrolling="no" style="position: absolute;"></iframe>');
  if (offset.zIndex)
    overlay.css("z-index", offset.zIndex);

  var resizeAction = fn.maxInterval(() => {
    var newCoordinates = target.offset();
    newCoordinates.left -= offset.Left;
    newCoordinates.top -= offset.Top;
    overlay.offset(newCoordinates);
    overlay.width(target.outerWidth() + offset.Width);
    overlay.height(target.outerHeight() + offset.Height);
  }, 25);

  return {
    Overlay: overlay,
    Show: () => {
      overlay.insertBefore(offset.Insert || target);
      target.on("resize", resizeAction);
      $(window).on("resize", resizeAction);
      $(window).bind("DOMSubtreeModified", resizeAction);
      resizeAction();

      target.trigger(ShowOverlay);
    },
    Hide: () => {
      overlay.remove();
      $(window).unbind("DOMSubtreeModified", resizeAction);
      target.off("resize", resizeAction);
      $(window).off("resize", resizeAction);

      target.trigger(HideOverlay);
    }
  };
}

export function ensureRowInfo(widget: kendo.ui.ListView | kendo.ui.Grid, customization: IGridCustomization, config?: { CurrentUser?: string }) {
  let rowItems = customization && customization.RowCustomizations,
    fields = customization && customization.FieldCustomizations;

  // problem: for building filter function via kendo.Query filter values must be typed,
  // "number", "date" typed formulas etc.willl fail otherwise!
  try {
    var modelFields = <kendo.data.DataSourceSchemaModelFields>kendo.getter("dataSource.options.schema.model.fields")(widget);
  } catch (err) {
    console.log("" + err);
  }
  if (modelFields && rowItems) {
    // Use "Compiled Copy" (to not manipulate orig filter Values)
    if (!rowItems._compiled) {
      rowItems = rowItems._compiled = rowItems.map(r => {
        r = fn.clone(r);
        var condition = r.Condition;
        if (Array.isArray(condition)) {
          r.Condition = NormalizeFilters(modelFields, condition, config);
        }
        return r;
      });
    } else {
      rowItems = rowItems._compiled;
    }
  }

  // Ensure that all custom CSS classes are available
  rowItems.forEach(EnsureStyle);

  var rowMatcher = GetOrCreateFirstMatchFunction(rowItems),
    fFields = fn.DictToArray(fn.Remap(fields || {}, (item, name) => {
      var m = GetOrCreateFirstMatchFunction(item);
      return { Field: name, Items: item, Matcher: m };
    })).filter(item => item.Items.length > 0);

  return {
    RowMatcher: rowMatcher,
    Fields: fFields
  };
}

/**  We know Overlay in WebKit not necessary at the moment, will even make builtin PDF Viewer flicker (TODO : only use in ADOBE scenriao?) */
export function UseOverlay() {

  if (typeof _UseOverlay === "boolean")
    return _UseOverlay;

  return _UseOverlay = !IsKendoMobile() && ($("html.k-webkit").length == 0);
}
var _UseOverlay: boolean;

/** Create Popup Overlay */
export function CreatePopUpOverlay(popUp: kendo.ui.Popup, openInitially?: boolean) {
  if (!UseOverlay() || !popUp || popUp["__InfOverlay"] || !(popUp instanceof kendo.ui.Popup))
    return;

  var openAction = () => {
    // Attention: Popup.Wrapper is most likely not attached to DOM on first call
    var items = $('.k-menu-group', popUp.element).add(popUp.element);
    var overlay = items.toArray().map((elem) => CreateOverlay($(elem), null));
    CurrentOverlays = overlay.map(item => item.Overlay);

    overlay.forEach(item => item.Show());
    popUp.one("close", () => {
      CurrentOverlays = [];
      overlay.forEach(item => item.Hide());
    });
  };
  var CurrentOverlays: JQuery[];
  popUp.bind("open", openAction);

  var activateAction = () => {
    // Assign z-index to show over parent window
    if (CurrentOverlays && CurrentOverlays.length > 0) {
      // Get z-index of following item to underlay (can be less than z-index of popup wrapper)
      var followingZindex = CurrentOverlays[0].next().css("zIndex");
      CurrentOverlays[0].css("zIndex", followingZindex);
    }
  };
  popUp.bind("activate", activateAction);
  popUp["__InfOverlay"] = true;

  // If iframe is needed on creation (element already visible)
  if (openInitially) {
    openAction();
    activateAction();
  }
}

/** kendo/UI Related constants */
export class constants {
  /**
  * We need virtualization or paging of grids for performance boost.
  * True = Virtualization, False = Paging
  * Virtualization has grouping bug (groups on other pages unreachable) in 2015 Q2
  */
  static USE_GRID_VIRTUALIZATION = false;

  static KendoCurrencyFormat = "{0:C}";
  static KendoDecimalFormat = "{0:n}";
  static KendoNumberFormat = "{0:n0}";
  static KendoPercentFormat = "{0}%";
  static KendoDateFormat = "{0:dd.MM.yyyy}";
  static KendoShortDateFormat = "{0:dd.MM.yy}";
  static KendoDateTimeFormat = "{0:dd.MM.yyyy HH:mm}";
  static KendoTimeFormat = "{0:HH:mm}";

  static cssInvalid = "idms_Invalid";
  /** Kendo grids default paging number */
  static DefaultPaging = 20;
  /** Kendo grid default available paging numbers */
  static DefaultPagings = [10, 20, 30, 40, 50];

  static GridEditRowSelector = "tr[data-uid][role='row']";
  static GridDataCell = ":not(.k-group-cell):not(.k-hierarchy-cell):visible";

  /** Size of command icon columns in kendo grids */
  static KendoGrid_ActionIconColumnSize = "35px";
  /** Size of larger command icon columns in kendo grids */
  static KendoGrid_ActionLargerIconColumnSize = "40px";
  /** Size of preview + supplement docs icon columns in kendo grids */
  static KendoGrid_PreviewIconColumnSize = "50px";
  /** Size of selection checkbox columns in kendo grids */
  static KendoGrid_SelectionColumnSize = "37px";

  /** Custom Event on destroying one of our Custom  Widgets
  *  - Never jquery.remove sub trees from DOM in Widget destructors unless all childs widgets are properly destroyed (will invalidate ALL data-* ... on all sub DOM Elements
  +  (- so if no control about Content, this should never be done!)
  *  (before jquery.remove ALL Child widgets must be destroyed, because they rely on data-* on their elements!) */
  static NavDestroy = "navDestroy";

  /** observable event triggered on a NavDock when Collapsed/Expanded (and on DockZone for a Child) */
  static ExpansionStateChanged = "expansionstatechanged";
}

/** Display Formats for Numeric values */
export const NumericFormat = {
  [NumericType.Number]: constants.KendoDecimalFormat,
  [NumericType.Currency]: constants.KendoCurrencyFormat,
  [NumericType.Percent]: constants.KendoPercentFormat
};

/** Display Formats for DateTime values */
export const DateFormat = {
  [NavDtFormat.Default]: constants.KendoDateFormat,
  [NavDtFormat.DateAndTime]: constants.KendoDateTimeFormat,
  [NavDtFormat.Time]: constants.KendoTimeFormat
};

/** kendo template functionality with defaulted TemplateOptions :  useWithBlock = false */
export function template(template: string) {
  return kendo.template(template, { useWithBlock: false });
}

/** Utiltiy to Wrap an Object as an Observable Object keeping Implicit Type- Information
(caution : to avoid heavy reRendering on Props not relevant to UI, start proNames with '_' [kendo convention])  */
export function WrapAsObservable<T>(item: T): T & kendo.data.ObservableObject {
  if (!item || item instanceof kendo.data.ObservableObject)
    return <T & kendo.data.ObservableObject>item;
  return $.extend(new kendo.data.ObservableObject(item), item); // TODO : why extend( <> EnsureObseravble?`)
}

/** bind Util returning unbind function */
export function Bind(on: Observable, f: Function, eventName: string) {
  on.bind(eventName, f);
  return fn.once(() => { on.unbind(eventName, f); });
}

/** Make Observable Object --> for Objects bound to Kendo ui (wOut we loose object equality ....) */
export function EnsureObservable<T>(item: T): T & kendo.data.ObservableObject {
  if (!item || item instanceof kendo.data.ObservableObject)
    return <T & kendo.data.ObservableObject>item;

  return <any>new kendo.data.ObservableObject(item);
}

/** Get Typed access as Observable Array */
export function AsObservableArray<T>(items?: ArrayLike<T>): IObservableArray<T> {
  if (!items)
    items = [];
  else if (items instanceof ObservableArray)
    return <IObservableArray<T>><any>items;

  return <IObservableArray<T>><any>new ObservableArray(<T[]>items);
}

/** Replace only "Changed" data, id'ed by getKey, Compared by compareFunc( defaults to "JSON.stringify"),
Returns true if changes took place (insert, delete, replace)
* (For UI (e.g Grid) Bound data a full replace is a Performance issue!*/
export function ReplaceObservableData<T>(observable: IObservableArray<T>, items: T[], getKey: (item: T) => any, compareFunc?: (item1: T, item2: T) => boolean) {
  // Handle Simple scenarios
  if (observable.length == 0) {
    // no previus items
    if (items.length > 0) {
      observable.splice(0, observable.length);
      observable.push(...items);
    }
    return items.length > 0;
  } else if (items.length == 0) {
    // Clear items
    observable.splice(0, observable.length);
    return true;
  }
  compareFunc = compareFunc || ((a, b) => JSON.stringify(a) == JSON.stringify(b));
  let loadInfo = fn.OuterJoin(observable, items, getKey, (existing, newItem) => {
    return {
      Loaded: newItem,
      Exist: existing,
      Action: (!newItem) ? "Delete" : (!existing ? "Add" : (!compareFunc(newItem, existing) ? "Change" : ""))
    };
  }), hasChanges = false,
    changeCount = loadInfo.filter(item => !!item.Action).length;
  if (changeCount == 0) {
    // nothing to do
  }
  else if ((changeCount == loadInfo.length) || (changeCount > 5)) {
    // Full Refresh : Perf Optimized
    hasChanges = true;
    observable.splice(0, observable.length, ...items);
  } else {
    // Apply Changes per item
    hasChanges = true;
    loadInfo.forEach(loadItem => {
      switch (loadItem.Action) {
        case "Delete":
          observable.splice(observable.indexOf(loadItem.Exist), 1);
          break;
        case "Add":
          observable.push(loadItem.Loaded);
          break;
        case "Change":
          observable.splice(observable.indexOf(loadItem.Exist), 1, loadItem.Loaded);
          break;
        default:
        // ??
      }
    });
  }

  return hasChanges;
}

/** - for building filter function via kendo.Query filter values must be typed (type : number, date)
*   - handle 'formulas' (@heute/taoday, @ich/me/currentuser/user)
*   - handle "Date" values + equal operator : compare date part only ....
*  returns adjusted container of filter items (clones, count might be changed ...)
*/
export function NormalizeFilters(model: kendo.data.DataSourceSchemaModelFields, filters: kendo.data.DataSourceFilterItem[],
  config?: { CurrentUser?: string }) {
  if (!filters || !$.isArray(filters))
    return filters;

  return fn.FlattenArray(filters.map(f => {
    var f = fn.clone(f),
      field = model && model[f.field],
      value = f.value;

    // Handle "current user handling
    if (config && config.CurrentUser !== undefined) {
      if (/^@(ich|me|user|currentuser)/i.test(("" + value).trim())) {
        value = f.value = config.CurrentUser;
      }
    }

    switch (field && field.type) {
      case "number":
        var asNumber = parseFloat(value);
        if (!isNaN(asNumber))
          f.value = asNumber;
        break;
      case "date":
        f.value = handleDateInput(value);
        break;
      default:
      //??
    }

    // Handle Date + "equal" : ignore time Part
    // by mapping to gte/lte operator pair
    if (f.value instanceof Date) {
      const theDate = f.value as Date;
      const checkSeconds = theDate.getTime() / (24 * 60);
      if (Math.floor(checkSeconds) === checkSeconds) { // only if no time part in Value
        if ((!f.operator || f.operator === "eq")) {
          var upperBound = fn.clone(f);
          upperBound.operator = "lt";
          var upperDate = new Date(theDate.valueOf());
          upperDate.setUTCDate(upperDate.getUTCDate() + 1);
          upperBound.value = upperDate;
          f.operator = "gte";
          return [f, upperBound];
        }
        else if (f.operator == "lte") {
          theDate.setHours(23, 59, 59, 999);
        }
      }
    }

    return [f];
  }));

  /** Translate "$heute/$today" formulas to actual date
  * '@heute', @heute + 4, @heute + 1m, heute - 1y
   */
  function handleDateInput(input: any) {
    if (!input)
      return <Date>input;

    var strInput = ("" + input).trim(),
      dateFormula = /^@(?:heute|today)\s*(([\+|\-])\s*([0-9]+)?([T|M|W|J|Y]?))?$/i.exec(strInput);

    if (!(dateFormula && dateFormula.length > 0))
      return kendo.parseDate(input) || input;

    // We have a formula
    let isSubtract = dateFormula[2] === "-",
      amount = (isSubtract ? -1 : 1) * (dateFormula[3] && parseInt(dateFormula[3])) || 0,
      marker = (dateFormula[4] || "T").toUpperCase(),
      _date = new Date(),
      year = _date.getFullYear(),
      month = _date.getMonth(),
      date = new Date(year, month, _date.getDate());

    switch (marker) {
      case "T":
        date.setDate(date.getDate() + amount);
        break;

      case "W":
        amount = 7 * amount;
        date.setDate(date.getDate() + amount);
        break;

      case "M":
        date.setMonth(date.getMonth() + amount); // 31?
        break;

      case "J":
      case "Y":
        date.setFullYear(date.getFullYear() + amount);
        break;

      default:
      // ??
    }

    return date;
  }
}

/** Create Formaula Access from String, return Refresh from Item function */
export function CreateFormula(config: {
  /** the formula to create */
  formula: FilterDefinition,
  /** callback on calculated Vaue changes */
  onChange(val: any)
  /** callback on error, if result == true, do not propagate */
  onError?: (err) => boolean,
}) {
  config.onError = config.onError || (() => false);
  try {
    var funcFormula = CreateFunction(config.formula);
    var currValue;
    var refresh = (item) => {
      try {
        var newValue = funcFormula(item);
        if (currValue !== newValue) {
          currValue = newValue;
          config.onChange(currValue);
        }
      } catch (err) {
        if (config.onError(err && err.Message || err) !== false)
          throw err;
      }
    };
    return refresh;
  } catch (err) {
    if (config.onError(err && err.Message || err) !== false)
      throw err;
  }
  return (item) => { };
}

/** Create Function from  */
function CreateFunction(definition: FilterDefinition) {
  if (typeof (definition) == "string")
    return new Function("item", "with(item) { return (" + definition + "); }");
  if (definition.length > 0) {
    return CompileFilters(<kendo.data.DataSourceFilterItem[]>definition);
  } else {
    throw new Error('Failed to Create Function from definition');
  }
}

/** From Container of objects with attached Conditions,
* build function to return first match if any
* (attach on base array via '__CalculatedFirstMatch' to ensure single Instance
**/
export function GetOrCreateFirstMatchFunction<T extends { Condition: FilterDefinition, Disabled?: boolean }>(items: (T[] & { __CalculatedFirstMatch?: (any) => T })): (any) => T {
  if (!items || items.length == 0)
    return fn.noop;

  // Check if already build and attached ...
  var result = items.__CalculatedFirstMatch;
  if (typeof (result) == "function")
    return result;

  var matchers = items.map(item => {
    var f = <(any) => boolean>fn.ToFunc(false);
    if (item && !item.Disabled) {
      try {
        f = <any>CreateFunction(item.Condition);
      } catch (err) { }
    }
    var isMatch = (item: any) => { try { return !!f.call(item, item); } catch (err) { return false; } };
    return {
      IsMatch: isMatch,
      Base: item
    };
  });

  return items.__CalculatedFirstMatch = (item) => { var m = fn.FindFirst(matchers, test => test.IsMatch(item)); return m && m.Base; };
}

/** Util to allow different rendering in excel export */
export function InExcelSaveOp() {
  return _InExcelSaveOp;
}
var _InExcelSaveOp = false;

function WrapExcelSaveOp<T>(f: () => T) {
  _InExcelSaveOp = true;
  try {
    return f();
  } finally {
    _InExcelSaveOp = false;
  }
}

/** Save Multiple Grids Contents ( actually there corresponding DataSources) in a Single Excel File */
export function SaveAsExcel(grids: Array<{ Grid: kendo.ui.Grid; Name?: string }>, excel?: kendo.ui.GridExcel) {
  // Set up workbook promises
  var books = grids.map(gridInfo => {
    var grid = gridInfo.Grid;
    var lExcel: any = excel || grid.options.excel || {};
    const gridDataSource = grid.dataSource;
    // Undocumented in Typescript definition File
    var exporter = new (<any>kendo).ExcelExporter({
      columns: grid.columns,
      dataSource: gridDataSource,
      allPages: lExcel.allPages,
      filterable: lExcel.filterable,
      hierarchy: lExcel.hierarchy,
    });

    // Propagate Hacked Filter logic to Export ...
    const fields = gridDataSource.options?.schema?.model?.fields;
    const filters = gridDataSource.filter()?.filters;
    const exportDataSource = exporter.dataSource;
    if (exportDataSource && exportDataSource !== gridDataSource && fields && filters?.length > 0) {
      exporter.dataSource.filter(NormalizeFilters(fields, filters));
    }
    return <JQueryPromise<kendo.ooxml.Workbook>>WrapExcelSaveOp(() => exporter.workbook());
  });

  $.when(...books).then(function () {
    //TODO: WTF - Adapt to kendo 2015 Q1 changes
    var resolvedOptions = books.length > 1 ?
      <kendo.ooxml.WorkbookOptions[]>fn.FlattenArray(<any>arguments) :
      <kendo.ooxml.WorkbookOptions[]>Array.prototype.slice.call(arguments);

    UISafe(() => {
      var workbook = new kendo.ooxml.Workbook({
        sheets: resolvedOptions.map(option => option.sheets && option.sheets[0]).filter(item => !!item),
      });

      // Apply Names
      workbook.options.sheets.forEach((sheet: any, idx) => {
        var info = grids[idx];
        if (info && info.Name && sheet)
          sheet.title = info.Name;
      });

      // save the new workbook
      kendo.saveAs({
        forceProxy: true, // see kendo documentation : Using a server proxy is highly recommended for files over 1MB or more. You may get a "Unknown network error" if the file is too large to be saved without a proxy.
        dataURI: workbook.toDataURL(),
        fileName: excel && excel.fileName ? excel.fileName : "export.xlsx",
        proxyURL: "./infoma.Web.Nav/IndirectDownload"
      });
    });
  });
}

/** Hide the pager of a kendo grid on databound event if there is only one page and not filter! (x of y Info) */
function HidePagerOnSinglePage(e: kendo.ui.GridDataBoundEvent) {
  var grid = e && e.sender,
    ds = grid && grid.dataSource,
    pg = grid.pager;

  if (ds && pg) {
    var needsPager = (ds.totalPages() > 1) || (ds.total() > constants.DefaultPaging);

    if (needsPager) {
      pg.element.show();
      pg.element.trigger('resize'); // US-133205
    } else {
      pg.element.hide();
    }
  }
}

/** Ensure that at least one tab ob a kendo tabstrip is selected (after visible tabs have changed) */
export function EnsureCheckedTab(tab: kendo.ui.TabStrip) {
  // Wait for UI to refresh
  setTimeout(() => {
    if (tab) {
      var tabActive = false;
      var firstShownIndex = -1;
      tab.tabGroup.children().each((index, elem) => {
        var isActive = $(elem).hasClass("k-state-active");
        var isShown = $(elem).css("display") !== "none";
        var isTabStateValid = isActive && isShown;

        if (isShown && firstShownIndex < 0)
          firstShownIndex = index;

        if (isTabStateValid) {
          tabActive = true;
          return false;
        }
      });

      if (!tabActive) {
        tab.select(firstShownIndex);
      }
    }
  }, 100);
};

/** Resolve Group Info for Grid  */
export function GetGroupInfo(options: kendo.data.DataSource | kendo.ui.GridOptions) {
  if ("dataSource" in options)
    options = options["dataSource"] || options;

  if (options instanceof kendo.data.DataSource)
    var groups = <any[]>options.group() || [];
  else if ("group" in options)
    var groups = <any[]><any>options["group"];

  if (!groups || !$.isArray(groups))
    groups = [];

  return groups.map(g => { return <kendo.data.DataSourceGroupItem>{ field: g.field, dir: g.dir }; });
}

/** Add tooltip to each kendo grid header column (dynamic, too) */
function AddGridHeaderTooltips(grid: kendo.ui.Grid) {
  if (grid && $.fn.kendoTooltip) {
    // Only add tooltip once
    var tooltip = grid.thead.data("kendoTooltip");
    if (!tooltip) {
      grid.thead.kendoTooltip({
        filter: "th:not(:empty) a.k-link", // No tooltip for empty field
        content: function (e) {
          return $("<div/>").text(e.target.text()).html();
        },
        position: "top"
      });
    }
  }
}

/** Get Grid From Context of Event */
export function GetGrid(e: Event) {
  const ctx = $(e.target || e.currentTarget || e);

  // Find closest ancestor (including self) with kendoGrid
  let grid = ctx.parents().addBack().filter(function () {
    return $(this).data("kendoGrid") !== undefined;
  }).first().data("kendoGrid");

  if (!grid) {
    // If not found, try kendoNavGrid
    grid = ctx.parents().addBack().filter(function () {
      return $(this).data("kendoNavGrid") !== undefined;
    }).first().data("kendoNavGrid");
  }

  return grid;
}

/** Get columns of the kendo grid under mouse pointer */
export function GetGridColumns(e: JQueryEventObject) {
  if (e && e.target) {
    var kgrid = GetGrid(e);
    return kgrid && kgrid.columns;
  }
}

export interface ICustomCommandItem {
  className?: string;
  title: string;
  iconClass: string;
  name: string;
  action: (item: kendo.data.ObservableObject) => void;
}

export function GetCommandItem(commandItem: ICustomCommandItem): kendo.ui.GridColumnCommandItem {
  return {
    // overwrite default template: problem with anchor tag ...
    // default: '<a class="k-button k-button-icontext #=className#" #=attr# href="\\#"><span class="#=iconClass# #=imageClass#"></span>#=text#</a>'
    template: resolveKendoVersion(
      '<a class="k-button k-button-icontext #=className#" #=attr# ><span class="#=iconClass# #=imageClass#"></span>#=text#</a>',
      undefined),
    name: commandItem.name,
    className: commandItem.className || "idms_DataGridButton",
    text: <any>"",
    attr: { title: commandItem.title },
    iconClass: commandItem.iconClass,
    click: (e) => {
      const grid = GetGrid(e);
      const row = $(e.currentTarget || e).closest("tr");
      grid.select(row);
      const dataItem = grid.dataItem(row);
      if (dataItem) {
        commandItem.action(dataItem);
      }
      return false; // imp 'prevent default'
    }
  };
}

/** Get Display Value for Grid Column for given underlying data */
export function GetDisplayValue(column: GridColumn, content: kendo.data.ObservableObject): any {
  if (!(column && column.field))
    return;

  var val = content.get(column.field);

  // Adapt content by mapping or template?
  // Map value to label from grid?
  var valMap = column.values;
  if (valMap) {
    var translation = valMap.filter(t => t.value === val);
    if (translation && translation.length > 0) {
      val = translation[0].text;
    }
  }

  if (column.format && (val !== null && val !== undefined)) {
    val = kendo.format(column.format, val);
  }

  // Use template?
  var templ = column.template;
  if (templ) {
    var kTempl = typeof templ === "function" ? templ : template(templ);
    var renderedTempl = kTempl(content);
    // Only render non html template
    if (renderedTempl && renderedTempl.indexOf("<") < 0) {
      val = renderedTempl;
    }
  }

  return val;
}

/**
* Set the max kendo grid height, regarding the surrounding elements of the content.
*
* ATTENTION:
* The container of the grid must have a fixed height!
* If the height is dynamic (e.g. window that sizes by its content) there might be a calculation mismatch on non-px units on grid elements in IE + FF.
*/
export function SetMaxGridHeight(kgrid: kendo.ui.Grid, maxHeight: number, minHeight: number = 0) {
  if (kgrid && maxHeight >= 0) {
    /** Check grid parts visibility and only return existing and visible elements */
    var checkVisibility = (elem: JQuery) => {
      return elem && elem.length > 0 && elem.is(":visible") && elem;
    };

    /** Get the outer height of an element by regarding its visibility */
    var getHeight = (elem: JQuery) => {
      return elem ? elem.outerHeight(true) : 0;
    };

    // Grid parts ()k-grid-header
    var toolbarElem = checkVisibility(kgrid.wrapper.find(".k-header.k-grid-toolbar")),
      groupingElem = checkVisibility(kgrid.wrapper.children(".k-grouping-header")),
      headerElem = checkVisibility(kgrid.thead.closest(".k-grid-header")),
      pagerElem = checkVisibility(kgrid.pager && kgrid.pager.element),
      footerElem = checkVisibility(kgrid.footer);

    // Grid part heights
    var outerBorder = kgrid.wrapper.outerHeight(true) - kgrid.wrapper.innerHeight(),
      gridHeight = Math.max(minHeight, maxHeight),
      toolbarHeight = toolbarElem ? toolbarElem.outerHeight(true) : 0,
      gridGroupingHeight = getHeight(groupingElem),
      gridHeaderHeight = getHeight(headerElem),
      gridPagerHeight = getHeight(pagerElem),
      gridFooterHeight = getHeight(footerElem);

    // ATTENTION: Will only work reliable on visible grids!
    var isVisible = kgrid.wrapper.is(":visible");
    if (!isVisible) {
      // Grouping, Header and Pager differs on invisible.
      if (gridGroupingHeight > 0) gridGroupingHeight = 35;
      var hasFilter = kgrid.thead.find(".k-filter-row").length > 0;
      gridHeaderHeight = Math.max(hasFilter ? 72 : 32, gridHeaderHeight);
      gridPagerHeight = Math.max(39, gridPagerHeight);
    }
    var newGridContentHeight = gridHeight - gridHeaderHeight - gridPagerHeight - gridFooterHeight - gridGroupingHeight - toolbarHeight - outerBorder;
    newGridContentHeight = Math.max(minHeight, newGridContentHeight);

    // Debug
    //var currMaxHeight = kgrid.content.css("max-height");
    //var currHeight = kgrid.content.height();
    //var contentBorder = kgrid.content.outerHeight(true) - currHeight;

    //infoma.debug.SetDebug(true);
    //infoma.debug.AddDebug("ContainerH: " + kgrid.wrapper.parent().height() + ", MaxH: " + maxHeight +
    //    ", GroupingH: " + gridGroupingHeight + ", ToolbarH: " + toolbarHeight + ", HeadH: " + gridHeaderHeight +
    //    ", oldContentHeight: " + currHeight + "(" + currMaxHeight + "/B:" + contentBorder + ")" + ", newContentHeight: " + newGridContentHeight
    //    , "AdaptiveGridHeight");

    kgrid.content.css({
      "height": "auto",
      "min-height": minHeight + "px",
      "max-height": newGridContentHeight + "px",
      "overflow-y": "auto"
    });

    // Keep locked columns in sync and force Kendo to re-measure rows/viewport.
    if (kgrid.lockedContent && kgrid.lockedContent.length > 0) {
      kgrid.lockedContent.css({
        "height": "auto",
        "min-height": minHeight + "px",
        "max-height": newGridContentHeight + "px"
      });
    }
    if (typeof (<any>kgrid).resize === "function") {
      (<any>kgrid).resize();
    }
  }
}

/** Get row item under mouse pointer */
export function GetRowItem(evt: Event | kendo.data.ObservableObject): kendo.data.ObservableObject {
  if (evt) {
    if (evt instanceof kendo.data.ObservableObject) {
      return <kendo.data.ObservableObject><any>evt;
    }
    var kgrid = GetGrid(evt);
    var row = $(evt.target).closest("tr"); //evt.currentTarget
    if (kgrid && row && !row.hasClass("k-grouping-row")) {
      return kgrid.dataItem(row);
    }
  }

  return null;
}

/**  Compile kendo filters fto delegate (copied from kendo.ui ...) */
export function CompileFilters(filters: kendo.data.DataSourceFilterItem[] | kendo.data.DataSourceFilters): (p: any) => boolean {
  var predicate,
    fields,
    operators,
    filter;

  if (Array.isArray(filters)) {
    const expressions = kendo.data.Query.normalizeFilter(filters as any);

    if (!expressions || expressions.filters.length === 0) {
      return (p) => true;
    }

    const compiled = kendo.data.Query.filterExpr(expressions);
    fields = compiled.fields;
    operators = compiled.operators;

    predicate = filter = new Function("d, __f, __o", "return " + compiled.expression);

    if (fields.length || operators.length) {
      filter = function (d) {
        return predicate(d, fields, operators);
      };
    }
    return filter;
  } else {
    var subFilters = filters.filters;
    if (filters.logic != "or") {
      // and
      return CompileFilters(subFilters)
    } else {
      // or
      const subPredicates = subFilters.map(f => CompileFilters([f]));
      return function (d) {
        return !!subPredicates.find(subpredicate => subpredicate(d))
      }
    }
  }
}

/** Settings Persistence Handling for kendo Window (height, width, position, maximized */
export function GetWindowSettings(initOptions: kendo.ui.WindowOptions, getWindow: () => kendo.ui.Window) {
  return CreateSetting(() => {
    var window = getWindow();
    var options = (window && window.options) || initOptions || <kendo.ui.WindowOptions>{};
    return {
      height: options.height,
      width: options.width,
      position: options.position && { top: options.position.top, left: options.position.left },
      isMaximized: options["isMaximized"]
    };
  }, settings => {
    if (!settings)
      return;
    var window = getWindow();

    var setOptions = window && window.options || initOptions || <kendo.ui.WindowOptions>{};
    ["height", "width", "position"].forEach(p => {
      var toSet = settings[p] || setOptions[p];
      if ($.isPlainObject(toSet)) // avoid external obj. References
        toSet = fn.clone(toSet);
      setOptions[p] = toSet;
    });
    if (window) {
      // TODO : applying options this way will invalidate custom client evnt handlers, at least the way we bound them.
      //window.setOptions(setOptions);
      window["_dimensions"]();
      window["_position"]();

      if (settings.isMaximized)
        window.maximize();
    }
  });
}

/** Get a kendo grid DataSource with included MetaData to be displayed in the grid */
export function GetGridDataSource(displayData, model?: typeof Model, dsOptions?: kendo.ui.GridOptions) {
  var pageable = dsOptions && dsOptions.pageable;
  if (pageable && typeof pageable !== "boolean") {
    var pageSize = pageable.pageSize;
  }
  // Default options
  var options = <kendo.data.DataSourceOptions>{
    data: displayData,
    pageSize: pageSize && constants.DefaultPagings.indexOf(pageSize) >= 0 ?
      pageSize : constants.DefaultPaging
  };

  if (model) {
    options.schema = {
      model: model
    };
  }

  /** Adjust Filter Logic (DateTime ....) ; dirty hack : "_queryProcess"*/
  var formattedDataSource = new kendo.data.DataSource(options);
  var _queryProcess = formattedDataSource["_queryProcess"];
  if (typeof _queryProcess === "function") {
    _queryProcess = _queryProcess.bind(formattedDataSource);
    formattedDataSource["_queryProcess"] = fn.proxy(function (data, options: { filter?: { filters: kendo.data.DataSourceFilterItem[] } }) {
      var filter = options && options.filter;
      var filters = filter && filter.filters;

      if ($.isArray(filters))
        var fixFilters = NormalizeFilters(model && model.fields, filters);

      if (filters && fixFilters)
        filter.filters = fixFilters;
      try {
        var result = _queryProcess(data, options);
      } finally {
        if (filters && fixFilters)
          filter.filters = filters;
      }

      return result;

    }, formattedDataSource);
  }
  return formattedDataSource;
}

/**
 * Must be called for each GridOption after dataBound event is set and before options are passed to initialize the grid.
 * This ensures a better performance and default behavior for all kendo grids.
 */
export function UpdateGridOptions(options: kendo.ui.GridOptions) {
  options = options || {};

  if (constants.USE_GRID_VIRTUALIZATION) {
    // Virtualization
    options.scrollable = { virtual: true };
  } else {
    // Paging
    options.pageable = options.pageable || {
      pageSize: constants.DefaultPaging,
      pageSizes: constants.DefaultPagings
    };

    var oldDataBound = options.dataBound;
    options.dataBound = e => {
      // Add "hide pager on single page" behavior
      HidePagerOnSinglePage(e);

      // Call old databound event?
      if (oldDataBound && oldDataBound !== HidePagerOnSinglePage) {
        oldDataBound(e);
      }

      // Add header Tooltips
      AddGridHeaderTooltips(e.sender);
    };
  }
  return options;
}

/**
 * Utility to Create Kendo Templates with implicit 'exposing' of local transform functions
 * @param template
 * @param funcMap
 * @param _VARNAME_
 */
export function CreateTemplate(template: string, funcMap: { [name: string]: ((...args) => any) } = {}, _VARNAME_ = '_VARNAME_') {
  interface Has__INFOMA_TEMPLATES { __INFOMA_TEMPLATES?: any; };
  const prefix: keyof Has__INFOMA_TEMPLATES = "__INFOMA_TEMPLATES",
    globalContext: Has__INFOMA_TEMPLATES = <Window & Has__INFOMA_TEMPLATES>window,
    __INFOMA_TEMPLATES = globalContext.__INFOMA_TEMPLATES || (globalContext.__INFOMA_TEMPLATES = {});

  for (var f in funcMap) {
    const funcName = "f" + ++_templateCounter;
    __INFOMA_TEMPLATES[funcName] = funcMap[f];
    template = template.split(f).join(prefix + "." + funcName);
  }

  return (varName) => template.split(_VARNAME_).join(varName);
}
var _templateCounter = 0;

/** Returns a kendo template with an integrated OverDue field */
export function GetOverDueTemplate(dueField: string, format: string, prefix?: string) {
  format = format != null ? format : constants.KendoDateFormat;
  prefix = "data." + (prefix || "");
  dueField = prefix + dueField;
  var dateFormat = "#: " + dueField + " != null ? kendo.format('" + format + "', " + dueField + ") : '' #";

  var templ =
    "#" +
    "try { var filter = " + prefix + "_filter; } catch(err) { }" +
    "var isCritical = filter && filter['CriticalDue'];" +
    "var isOverDue = filter && " + dueField + " &&  (new Date() > " + dueField + ");" +
    "var dueClass = isOverDue ? 'idms_BGColor_Error' : (isCritical ? 'idms_BGColor_Warning' : '');" +
    "#" +
    "<div class='idms_GridCellMarked idms_truncate #= dueClass #'>" +
    dateFormat +
    "</div>";

  return templ;
}

/** Returns a kendo template with an integrated Created field that can append the duration calculated from the created field  */
export function GetDurationTemplate(createdFieldName: string, showDuration: boolean, format: string, prefix?: string) {
  prefix = "data." + (prefix || "");
  createdFieldName = prefix + createdFieldName;
  format = format != null ? format : constants.KendoDateTimeFormat;
  var dateFormat = "#: " + createdFieldName + " != null ? kendo.format('" + format + "', " + createdFieldName + ") : '' #";
  var durationTempl = showDuration ? " - vor <strong>#: days #</strong> Tag#:  days !== 1 ? 'en' : '' #" : "";
  var templ =
    "#" +
    "var days = infoma.fn.GetDayDifference(" + createdFieldName + "); " +
    "try { var filter = " + prefix + "_filter; } catch(err) { }" +
    "var isCritical = filter && filter['CriticalDuration']; " +
    "var dueClass = isCritical ? 'idms_BGColor_Warning' : '';" +
    "#" +
    "<div class='idms_GridCellMarked idms_truncate #= dueClass #'>" +
    dateFormat + "# if(days == 0) { # - <strong>heute</strong> #  } else if(!isNaN(days)) { #" + durationTempl + "# } #" +
    "</div>";

  return templ;
}

/** Returns a kendo template with an integrated Amount field */
export function GetAmountTemplate(amountFieldName: string, format: string, criticalFormula?: string, criticalClass?: string, prefix?: string) {
  prefix = "data." + (prefix || "");
  amountFieldName = prefix + amountFieldName;
  format = format != null ? format : constants.KendoDecimalFormat;
  var amountFormat = "#= " + amountFieldName + " != null ? kendo.format('" + format + "', " + amountFieldName + ") : '' #";
  var templ =
    "#" +
    "try { var isAmountCritical = " + (criticalFormula ? criticalFormula : prefix + "_filter['CriticalAmount']") + ";} catch(e) {};" +
    "var amountClass = isAmountCritical ? " + (criticalClass ? "'" + criticalClass + "'" : "'idms_BGColor_Warning'") + ": '';" +
    "#" +
    "<div class='idms_GridCellMarked idms_CurrencyField idms_truncate #= amountClass #'>" + // Right align with CSS-Class: idms_CurrencyField
    amountFormat +
    "</div>";

  return templ;
}

// Startup Kendo Culture ....
var kendoDefined = false;
var kendoCultureDefined = false;
try { if (kendo) { kendoDefined = true; if (kendo.culture) { kendoCultureDefined = true; } } } catch (err) { }
// Ensure Cultulre
if (kendoCultureDefined) {
  // take first available of used ones
  var setMatch = ["de-CH", "de-DE"].filter(item => !!kendo.cultures[item])[0];
  if (setMatch)
    kendo.culture(setMatch);
}

/** Hack to adjust dateTime grouping (must be checked for
// each new kendo version by copying original kendo.data.Query.groupBy
//  and 'injecting' custom 'groupValueComparer'"") */
function AdjustDateTimeGrouping() {
  const isEmptyObject = $.isEmptyObject;
  const Query = kendo.data.Query;

  function groupBy_2016(descriptor) {
    if (isEmptyObject(descriptor) || !this.data.length) {
      return new Query([]);
    }
    var field = descriptor.field, sorted = this._sortForGrouping(field, descriptor.dir || 'asc'), accessor = kendo.accessor(field), item, groupValue = accessor.get(sorted[0], field), group = {
      field: field,
      value: groupValue,
      items: []
    }, currentValue, idx, len, result = [group];
    for (idx = 0, len = sorted.length; idx < len; idx++) {
      item = sorted[idx];
      currentValue = accessor.get(item, field);
      if (!groupValueComparer(groupValue, currentValue)) {
        groupValue = currentValue;
        group = {
          field: field,
          value: groupValue,
          items: []
        };
        result.push(group);
      }
      group.items.push(item);
    }
    return new Query(result);
  };

  function groupBy_2019(descriptor) {
    var that = this;

    if ($.isEmptyObject(descriptor) || !this.data.length) {
      return new Query([]);
    }

    var field = descriptor.field,
      sorted = descriptor.skipItemSorting ? this.data : this._sortForGrouping(field, descriptor.dir || "asc"),
      accessor = kendo.accessor(field),
      item,
      groupValue = accessor.get(sorted[0], field),
      group = {
        field: field,
        value: groupValue,
        items: []
      },
      currentValue,
      idx,
      len,
      result = [group];

    for (idx = 0, len = sorted.length; idx < len; idx++) {
      item = sorted[idx];
      currentValue = accessor.get(item, field);
      if (!groupValueComparer(groupValue, currentValue)) {
        groupValue = currentValue;
        group = {
          field: field,
          value: groupValue,
          items: []
        };
        result.push(group);
      }
      group.items.push(item);
    }

    result = that._sortGroups(result, descriptor);

    return new Query(result);
  };

  // the original Version Compares by getTime ...
  function groupValueComparer(a, b) {
    if (a && a.getDate && b && b.getDate) {
      return a.getDate() === b.getDate();
    }
    return a === b;
  }

  var result = resolveKendoVersion(groupBy_2016, groupBy_2019);
  kendo.data.Query.prototype["groupBy"] = result || kendo.data.Query.prototype["groupBy"];
  return !!result;
}

/** Marker : Hack for DateTime Grouping is handled */
export const DateTimeGroupingAdjusted = AdjustDateTimeGrouping();

/** Ways to dynamically create a 'filter' Function from some external Configuration */
export type FilterDefinition = string | kendo.data.DataSourceFilterItem[];

/** 'Structured' Description for Customization of HTML Markup */
export interface IMarkupCustomization extends IBaseMarkupCustomization {
  /** Textual Condition Expression, access to data as this.*,   */
  Condition: FilterDefinition;
  /** Marker : Currently not effective */
  Disabled?: boolean;
}

/** 'To Field Names' maps of Markup Customizations */
export interface IMarkupCustomizationMaps {
  [fieldName: string]: IMarkupCustomization[];
}

/** Grid Markup Customization Definition */
export interface IGridCustomization {
  /* Customizations for Rows */
  RowCustomizations?: IMarkupCustomization[] & {
    /** for internal use only */
    _compiled?: IMarkupCustomization[]
  };

  /** Customizations for Cells  */
  FieldCustomizations?: IMarkupCustomizationMaps;
}

/** Check for Kendo Mobile Application */
export function IsKendoMobile(): boolean {
  return $("body").data("kendoMobileApplication");
}

/** Some Functionality is not yet available in 'Mobile' Version .... */
export function ValidateNotKendoMobile() {
  if (IsKendoMobile())
    throw new Error('Diese Funktion steht aktuell nur in der Desktop-Ansicht zur Verfügung');
}

declare global {

  /** Undocumented Functionality in kendo typescript definition */
  namespace kendo {

    function initWidget(element: any, options: any, roles?: any);
    function accessor(name: string): { get: (onItem, field) => any, set: (name, value) => void };
    function parseQueryStringParams(url: string): any;
    function getter(path: string, safe?: boolean): ((context: any) => any);
    function setter(path: string): (context, value) => void;
  }

  namespace kendo.ui {
    interface ToolBarItem {
      align?: "left" | "right";
    }

    // #region Adjustment for Typescript Version compatibility (wOut CompileOnSave fails (different tsc Version in VS?)
    interface TooltipContent {
      (e: { sender: Tooltip, target: JQuery }): string;
    }

    //#endregion

    interface Event {
      sender: Widget;
      preventDefault: Function;
      isDefaultPrevented(): boolean;
    }

    interface GridColumn {
      /** Not Supported by base kendo Grid unfortunately, but implementet on NAV Grid derivative */
      infEditable?: boolean;
    }

    /** Typed Representation of Grid Column */
    export interface EntityGridColumn<TEntity> extends GridColumn {
      field?: keyof TEntity;
    }

    /** Typed Representation of Grid Options */
    export interface EntityGridOptions<TEntity> extends GridOptions {
      columns?: EntityGridColumn<TEntity>[];
    }

    interface GridColumnFilterable {
      messages?: {
        isTrue?: string,
        isFalse?: string,
        filter?: string,
        clear?: string,
        operator?: string
      };
    }
    interface GridColumnCommandItem {
      attr?: { [name: string]: string };
      iconClass?: string | GridColumnCommandItemIconClass;
      template?: string;
    }

    interface GridColumnCommandItemIconClass {
      edit?: string;
      update?: string;
      cancel?: string;
    }

  }

  namespace kendo.data {

    interface DataSourceOptions {
      autoBind?: boolean;
    }

    export namespace Query {
      export function filterExpr(filters: DataSourceFilters): { fields: any[], operators: any[], expression: string };
      export function normalizeFilter(filters: DataSourceFilterItem[]): DataSourceFilters;
    }

    interface QueryResult {
      total?: number;
      data?: any[];
    }

    export interface GroupInfo {
      hasSubgroups?: boolean;
      items?: GroupInfo[];
      value?: any;
    }

  }
}


export function SetRWFCustomColor(color: string | undefined) {
  onNext();
  if (!color) {
    return
  }
  var cssCode = `.rwfcustomcolor {background-color:  ${color} }`
  var styleElement = document.createElement("style") as any;
  styleElement.type = "text/css";
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = cssCode;
  } else {
    styleElement.appendChild(document.createTextNode(cssCode));
  }
  var added = document.getElementsByTagName("head")[0].appendChild(styleElement);
  onNext = () => added.remove();
}
var onNext: () => void = () => { };
